import React, { useState, useEffect } from 'react';
import ValidationMessage from '../question/ValidationMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons'


const LoginInput = (props: any) => {
    const [value, setValue] = useState<string>('');
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setError(props.submitError || null);
    }, [props.submitError]);

    const updateInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setValue(newValue);
        props.onChange(e);
        
    };

    const updateValidationMessage = () => {
        if (props.validate) {
            const validationError = props.validate(value);
            setError(validationError);
        } else {
            setError(null);
        }
    }
    return (
        <div className={props.page === "login" ? "login-input-container login" : "login-input-container"}>
        <br/>
            <label>{props.label}</label>
            <div className="input-container">
                <input  
                    className={error ? "validation-fail" : ''}
                    type={props.type}
                    name={props.name}
                    value={value}
                    placeholder={props.placeholder}
                    onChange={updateInputValue}
                    onBlur={updateValidationMessage}
                    disabled={props.disabled}
                />
                {error && <div className="input-error-message"><FontAwesomeIcon icon={faCircleExclamation} /> {error}</div>}
            </div>
        </div>
    );
};
export default LoginInput;